import { API } from "aws-amplify";

const show = async () => {
  let myInit = {
    // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  };
  let res = await API.get("NoPermissionAPI", "/maintenance", myInit);

  return res;
};

export default {
  show: show,
};
